import { Component, OnInit, Inject } from "@angular/core";
import { AddendumService } from "../services/addendum.service";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { Router, ActivatedRoute } from "@angular/router";
import { Addendum } from "../models/addendum";
import {
  AddendumStatusEnum,
  UserRoleEnum,
  StandardTypeEnum,
} from "../core/constant";
import { Observable } from "rxjs";
import { AddendumAttachment } from "../models/addendum-attachment";
import { CryptographyService } from "../services/cryptography.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { StandardService } from "../services/standard.service";
import * as CryptoJS from "crypto-js";
import { DatePipe, Location } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from "dompurify";
import {
  ExceptionTimelineEditEntry,
  ExceptionTimelineTracker,
} from "../models/exception-timeline-tracker";

export interface ExceptionTimelineEvent {
  title: string;
  date: Date;
  icon: string;
  tone:
  | "request"
  | "approved"
  | "rejected"
  | "expired"
  | "valid"
  | "renewed"
  | "updated";
  actor?: string;
  note?: string;
}

@Component({
  selector: "app-addendum",
  templateUrl: "./addendum.component.html",
  styleUrls: ["./addendum.component.scss"],
  providers: [DatePipe],
})
export class AddendumComponent implements OnInit {
  notes: SafeHtml;
  loading: boolean = false;
  userRole: number = 2;
  addendum: Addendum = new Addendum();
  error: string = "";
  invalidFile: boolean = false;
  invalidFileMessage: string = "";
  isExpiredorRejected: boolean = false;
  attachment: any = null;
  attachmentFinal: any = null;
  timelineEvents: ExceptionTimelineEvent[] = [];

  get addendumStatusEnum() {
    return AddendumStatusEnum;
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }
  get standardTypeEnum() {
    return StandardTypeEnum;
  }

  constructor(
    private addendumService: AddendumService,
    private standardService: StandardService,
    private router: Router,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private activeRoute: ActivatedRoute,
    private ngbModal: NgbModal,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private location: Location,

  ) {
    this.addendum.id = parseInt(
      this.activeRoute.snapshot.paramMap.get("addendumId")
    );
  }

  ngOnInit() {
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
    //this.getAAddendum(this.addendum.id);
    this.activeRoute.params.subscribe((routeParams) => {
      this.getAAddendum(routeParams.addendumId);
    });
  }

  getApprovalArray(): Date[] {
    let a = [];
    for (let i = 0; i < this.addendum.addendumApproval.length; i++) {
      if (this.addendum.addendumApproval[i].approvedDate != null)
        a.push(new Date(this.addendum.addendumApproval[i].approvedDate));
    }
    void 0;
    return a.reverse();
  }

  getLatestRequestedAttachment() {
    let attachment = null;
    for (let a of this.addendum.addendumAttachment) {
      // void 0;
      if (a.isRequestedFile == true) attachment = a;
    }
    void 0;
    return attachment;
  }
  getLatestApprovedAttachment() {
    let attachment = null;
    for (let i = 0; i < this.addendum.addendumAttachment.length; i++) {
      if (this.addendum.addendumAttachment[i].isRequestedFile == false) {
        attachment = this.addendum.addendumAttachment[i];
      }
    }
    return attachment;
  }
  getApprovedAttachmentsList() {
    let approvedAttachmentsList = [];
    for (let att of this.addendum.addendumAttachment) {
      // void 0;
      if (att.isRequestedFile != null && att.isRequestedFile == false)
        approvedAttachmentsList.push(att);
    }
    void 0;
    approvedAttachmentsList.reverse();
    return approvedAttachmentsList;
  }

  getRequestedAttachmentsList() {
    let approvedAttachmentsList = [];
    for (let att of this.addendum.addendumAttachment) {
      // void 0;
      if (att.isRequestedFile != null && att.isRequestedFile == true)
        approvedAttachmentsList.push(att);
    }
    void 0;
    approvedAttachmentsList.reverse();
    return approvedAttachmentsList;
  }
  /* Redirects to /update-addendum to renew the exception @return void*/
  redirectToRenew() {
    this.router.navigateByUrl("/update-addendum/" + this.addendum.id);
  }

  /**
   * Get a Addendum
   * @return void
   */
  getAAddendum(addendumId: number): void {
    this.loading = true;
    this.addendumService
      .getAddendumInformationByAddendumId(addendumId)
      .subscribe((data: any) => {
        try {
          // console.log("")
          if (!data) {
            this.loading = false;
            this.addendum = new Addendum(new Addendum(), this.userRole);
            void 0;
            const safenote = DOMPurify.sanitize(this.addendum.standard.note)
            this.notes = this.sanitizer.bypassSecurityTrustHtml(safenote);
            const modalRefd = this.ngbModal.open(FailModuleComponent);
            modalRefd.componentInstance.title = "No data!";
            modalRefd.componentInstance.errorMessage =
              "This Exception has been deleted from the database or not available for use!";
            modalRefd.componentInstance.redirectRoute = "/locations";
          } else {
            data.country = [data.country];
            data.countryId = [data.countryId];
            this.addendum = new Addendum(data, this.userRole);
            if (data.standard?.note) {
              const safenote = DOMPurify.sanitize(data.standard.note);
              this.notes = this.sanitizer.bypassSecurityTrustHtml(safenote);
            }
            void 0;
            this.loading = false;
            (error: string) => {
              this.error = error;
              this.loading = false;
            };
            if (data.addendumStatus.id == 3) this.isExpiredorRejected = true;
            if (data.addendumStatus.id == 4) this.isExpiredorRejected = true;
            this.attachment = this.getLatestRequestedAttachment();
            this.attachmentFinal = this.getLatestApprovedAttachment();
            this.refreshTimelineEvents();
          }
        } catch (e) {
          void 0;
        }
      });
  }

  approveOrRejectOrDraft(newAddendumStatusId: number): void {
    if (newAddendumStatusId) {
      this.loading = true;
      this.addendum.addendumStatusId = newAddendumStatusId;
      if (newAddendumStatusId == this.addendumStatusEnum.DraftAfterRequest) {
        // this.attachmentFinal.isRequestedFile = null;
      }
      if (newAddendumStatusId == this.addendumStatusEnum.Approved) {
        this.attachmentFinal.isRequestedFile = false;
      }
      if (this.attachmentFinal != null)
        // this.addendum.addendumAttachment.push(this.attachmentFinal);
        this.addendum.addendumAttachment = [this.attachmentFinal];
      else this.addendum.addendumAttachment = [];
      // if (this.attachmentFinal != null) {
      //   this.attachmentFinal.addendumStatus = newAddendumStatusId;
      // }
      this.addendum.modifiedUserId = this.cryptographyService.decryptData(
        this.storage.get("userId")
      );
      let addendumCopy: any = this.addendum;
      addendumCopy.countryIds = addendumCopy.countryId;
      addendumCopy.country = addendumCopy.country[0];
      delete addendumCopy.countryId;
      this.addendumService.updateAddendum(addendumCopy).subscribe((data) => {
        this.loading = false;
        this.getAAddendum(this.addendum.id);
        if (newAddendumStatusId == this.addendumStatusEnum.DraftAfterRequest) {
          if (
            this.addendum.standard.standardTypeId ==
            this.standardTypeEnum.GlobalEquipmentStandard
          ) {
            if (this.addendumService.isCommingFromNotification) {
              this.router.navigate(["/notification-list"]);
            } else if (this.addendumService.isCommingFromNrbes) {
              this.router.navigate(["/view-all-equipments"]);
            } else {
              this.router.navigate(["/equipment-addendum-list"]);
            }
          } else {
            if (this.addendumService.isCommingFromNotification) {
              this.router.navigate(["/notification-list"]);
            } else if (this.addendumService.isCommingFromNrbes) {
              this.router.navigate(["/nrbeslist"]);
            } else {
              this.router.navigate(["/addendum-list"]);
            }
          }
        }
        (error) => (this.error = error);
      });
    }
  }

  onSelectAAddendumDocument(event) {
    this.invalidFileMessage = "";
    let selectedFile = event.target.files[0];
    this.invalidFile =
      this.validateFileType(selectedFile.name) ||
      this.validateFileSize(selectedFile);
    this.convertToBaseString(selectedFile).subscribe((result) => {
      this.attachmentFinal = new AddendumAttachment();
      this.attachmentFinal.id = 0;
      this.attachmentFinal.fileName = selectedFile.name;
      this.attachmentFinal.addendumId = this.addendum.id;
      this.attachmentFinal.isRequestedFile = false;
      this.attachmentFinal.attachmentContentAsBase64 = result;
      event.target.value = null;
    });
  }

  onRemoveAddendumDocument() {
    this.attachmentFinal = null;
    this.invalidFile = false;
  }

  convertToBaseString(selectedFile): Observable<any> {
    return new Observable<any>((observer) => {
      var fileReader = new FileReader();
      if (fileReader && selectedFile) {
        fileReader.readAsDataURL(selectedFile);
        fileReader.onload = function () {
          observer.next(fileReader.result.toString());
        };
      }
    });
  }

  onDownloadAddendumDocument(id: number, fileName: string) {
    return this.standardService.getAttachmentUrl(id, true).subscribe(
      (response: any) => {
        const blob = new Blob([response], {
          type: response.type,
        });
        if (
          (window.navigator as any) &&
          (window.navigator as any).msSaveOrOpenBlob
        ) {
          (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
          return;
        }
        var a = document.createElement("a");
        document.body.appendChild(a);

        let url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);

        //window.open(url);
      },
      (error: any) => {
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage = error.error
          ? error.error.Message
          : error.message;
      }
    );
  }

  onDownloadSelectedAddendumDocument(id: number, fileName: string) {
    if (id) {
      return this.standardService.getAttachmentUrl(id, true).subscribe(
        (response: any) => {
          const blob = new Blob([response], {
            type: response.type,
          });
          if (
            (window.navigator as any) &&
            (window.navigator as any).msSaveOrOpenBlob
          ) {
            (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
            return;
          }
          var a = document.createElement("a");
          document.body.appendChild(a);

          let url = window.URL.createObjectURL(blob);

          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        }
      );
    } else {
      fetch(this.addendum.addendumAttachment[1].attachmentContentAsBase64)
        .then((res) => res.blob())
        .then((blob) => {
          if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveBlob(
              blob,
              this.addendum.addendumAttachment[1].fileName
            );
          } else {
            var a = document.createElement("a");
            a.href =
              this.addendum.addendumAttachment[1].attachmentContentAsBase64;
            a.setAttribute(
              "download",
              this.addendum.addendumAttachment[1].fileName
            );
            a.click();
          }
        });
    }
  }

  validateFileType(fileName: string) {
    let fileTypeArr = ["docx", "doc", "pdf", "jpg", "png", "bmp", "jpeg"];
    if (fileName != null) {
      let fileNameArr = [];
      let splitedFileName = fileName.toLowerCase().split(".");
      splitedFileName.forEach(function (obj) {
        fileNameArr.push(obj);
      });
      fileNameArr = fileNameArr.reverse();
      if (!fileTypeArr.includes(fileNameArr[0])) {
        this.invalidFileMessage = "Invalid file type.";
        return true;
      }
    }
  }

  validateFileSize(file: any) {
    if (file.size > 10485760) {
      this.invalidFileMessage = "File size exceeds maximum limit 10 MB.";
      return true;
    }
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.onOk();
    }
  }

  getApplicableToLabel(): string {
    if (!this.addendum?.country?.length) {
      return "—";
    }
    return this.addendum.country.map((c) => c.name).join(" & ");
  }

  getRequestedDocument(): AddendumAttachment | null {
    return this.getLatestRequestedAttachment();
  }

  getFinalDocument(): AddendumAttachment | null {
    return this.getLatestApprovedAttachment();
  }

  getDisplayDocument(): AddendumAttachment | null {
    return this.getFinalDocument() || this.getRequestedDocument();
  }

  getDocumentFileSize(attachment: AddendumAttachment | null): string {
    if (!attachment) {
      return "";
    }

    let bytes = 0;
    if (attachment.attachmentContent?.length) {
      bytes = attachment.attachmentContent.length;
    } else if (attachment.attachmentContentAsBase64) {
      const base64 = attachment.attachmentContentAsBase64.includes(",")
        ? attachment.attachmentContentAsBase64.split(",")[1]
        : attachment.attachmentContentAsBase64;
      bytes = Math.floor((base64.length * 3) / 4);
    }

    if (!bytes) {
      return "";
    }
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    return `${Math.round(bytes / 1024)} KB`;
  }

  canEditException(): boolean {
    return (
      (this.addendum.addendumStatusId == this.addendumStatusEnum.Expired ||
        this.addendum.addendumStatusId == this.addendumStatusEnum.Rejected) &&
      (this.userRole == this.userRoleEnum.MarketAdmin ||
        this.userRole == this.userRoleEnum.AOWAdmin)
    );
  }

  isExceptionActive(): boolean {
    return (
      this.addendum?.addendumStatusId === this.addendumStatusEnum.Approved &&
      !this.hasRenewalDatePassed()
    );
  }

  isExceptionExpired(): boolean {
    return (
      this.addendum?.addendumStatusId === this.addendumStatusEnum.Expired ||
      (this.addendum?.addendumStatusId === this.addendumStatusEnum.Approved &&
        this.hasRenewalDatePassed())
    );
  }

  showExceptionStatusBadge(): boolean {
    return this.isExceptionActive() || this.isExceptionExpired();
  }

  getExceptionStatusBadge(): string {
    return this.isExceptionActive()
      ? "/assets/images/exception active.svg"
      : "/assets/images/exception expired.svg";
  }

  private hasRenewalDatePassed(renewalDate?: Date | null): boolean {
    const date = renewalDate || this.getRenewalDate();
    if (!date) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiryDay = new Date(date);
    expiryDay.setHours(0, 0, 0, 0);
    return today.getTime() > expiryDay.getTime();
  }

  getExceptionTitle(): string {
    if (this.addendum?.title) {
      return this.addendum.title;
    }
    if (this.addendum?.description) {
      return this.addendum.description;
    }
    if (this.addendum?.standard?.title) {
      return `Exception for ${this.addendum.standard.title}`;
    }
    return "Standard Exception";
  }

  showExceptionDescription(): boolean {
    return !!this.addendum?.title && !!this.addendum?.description;
  }

  getStatusOnLabel(): string {
    if (this.addendum?.addendumStatus?.id === this.addendumStatusEnum.Rejected) {
      return "Rejected On";
    }
    if (this.addendum?.addendumStatus?.id === this.addendumStatusEnum.Expired) {
      return "Expired On";
    }
    return "Approved On";
  }

  getRenewalDate(): Date | null {
    return this.addendum?.exceptionRenewalDate || this.addendum?.expiryDate || null;
  }

  hasStatusOnDate(): boolean {
    return (
      this.addendum?.addendumStatusId != this.addendumStatusEnum.Requested &&
      !!this.addendum?.approvedOrRejectedDate
    );
  }

  showMetaDivider(): boolean {
    return !!this.getRenewalDate() && this.hasStatusOnDate();
  }

  getExceptionTimelineEvents(): ExceptionTimelineEvent[] {
    return this.timelineEvents;
  }

  private refreshTimelineEvents(): void {
    const events: ExceptionTimelineEvent[] = [];
    const status = this.addendum?.addendumStatusId;
    const requestActor = this.getRequestTimelineActor();
    const globalAdminActor = "By Global Admin";

    if (this.addendum?.created) {
      events.push({
        title: "Request Raised",
        date: new Date(this.addendum.created),
        icon: "/assets/images/requesr_raised.svg",
        tone: "request",
        actor: requestActor,
      });
    }

    const approvalDates = this.getApprovalDatesDescending();
    const statusOnDate = this.addendum?.approvedOrRejectedDate
      ? new Date(this.addendum.approvedOrRejectedDate)
      : null;
    const renewalDate = this.getRenewalDate();
    const editEntries = ExceptionTimelineTracker.getEditEntries(this.addendum?.id);

    // Only Global Admins ever approve/reject/set an exception's status or
    // renewal - never a Market Admin, regardless of who originally requested
    // it. "Request Raised" is the one event that keeps the requester's own name.
    if (status === this.addendumStatusEnum.Rejected && statusOnDate) {
      events.push({
        title: "Exception Rejected",
        date: statusOnDate,
        icon: "/assets/images/request-rejected.svg",
        tone: "rejected",
        actor: globalAdminActor,
      });
    } else if (
      status === this.addendumStatusEnum.Approved ||
      this.isExceptionExpired()
    ) {
      this.buildApprovedTimelineEvents(
        events,
        approvalDates,
        statusOnDate,
        renewalDate,
        editEntries,
        globalAdminActor
      );
    } else if (status === this.addendumStatusEnum.Expired) {
      const latestApproval = approvalDates[0];
      if (latestApproval) {
        events.push({
          title: "Exception Approved",
          date: latestApproval,
          icon: "/assets/images/exception_approved.svg",
          tone: "approved",
          actor: globalAdminActor,
        });
      }

      events.push({
        title: "Exception Expired",
        date:
          statusOnDate ||
          renewalDate ||
          latestApproval ||
          new Date(this.addendum.created),
        icon: "/assets/images/exception-expired.svg",
        tone: "expired",
      });
    }

    // Newest first, oldest last - read bottom to top: Request Raised (the
    // origin event) always anchors the bottom, most recent event on top (the
    // ".exception-timeline-item--last" marker drops the connecting line below
    // that oldest, final entry). Request Raised is pinned last unconditionally
    // rather than trusting raw date comparison - when an exception is approved
    // or rejected the same day it was raised, the two timestamps can be close
    // enough that precision alone doesn't reliably keep them in causal order.
    this.timelineEvents = events.sort((a, b) => {
      if (a.tone === "request") return 1;
      if (b.tone === "request") return -1;
      return b.date.getTime() - a.date.getTime();
    });
  }

  /**
   * Builds the Approved -> Valid Till -> (Expired) -> [Title/Description/Document
   * Updated] -> Renewed -> Valid Till (repeat) sequence, per the Figma reference.
   * Every renewal gets its own "Valid Till" announcement; if the next thing that
   * happens to the exception is later than that date, an "Exception Expired"
   * waypoint is inserted first, so lapsed periods are never silently skipped.
   */
  private buildApprovedTimelineEvents(
    events: ExceptionTimelineEvent[],
    approvalDates: Date[],
    statusOnDate: Date | null,
    renewalDate: Date | null,
    editEntries: ExceptionTimelineEditEntry[],
    globalAdminActor: string
  ): void {
    if (statusOnDate) {
      events.push({
        title: "Exception Approved",
        date: statusOnDate,
        icon: "/assets/images/exception_approved.svg",
        tone: "approved",
        actor: globalAdminActor,
      });
    }

    if (editEntries.length) {
      editEntries
        .slice()
        .sort(
          (first, second) =>
            new Date(first.editedAt).getTime() -
            new Date(second.editedAt).getTime()
        )
        .forEach((entry) => {
          this.appendEditTimelineEvents(events, entry, globalAdminActor);
        });
    } else {
      approvalDates
        .filter((date) => !this.isSameDay(date, statusOnDate))
        .forEach((date) => {
          events.push({
            title: "Exception Renewed",
            date,
            icon: "/assets/images/exception-renewed.svg",
            tone: "renewed",
            actor: globalAdminActor,
          });
        });
    }

    // The latest open-ended period's status, checked against today - always
    // reflects the addendum's current, fresh renewal/expiry date, never a
    // frozen value from an older edit entry, so this can never go stale after
    // a renewal-only update.
    this.pushValidTillOrExpiredEvent(events, renewalDate);
  }

  private appendEditTimelineEvents(
    events: ExceptionTimelineEvent[],
    entry: ExceptionTimelineEditEntry,
    globalAdminActor: string
  ): void {
    const editDate = new Date(entry.editedAt);

    if (entry.titleChanged) {
      events.push({
        title: "Exception Title Updated",
        date: editDate,
        icon: "/assets/images/d-edit 1.svg",
        tone: "updated",
        actor: globalAdminActor,
      });
    }

    if (entry.descriptionChanged) {
      events.push({
        title: "Exception Description Updated",
        date: editDate,
        icon: "/assets/images/description.svg",
        tone: "updated",
        actor: globalAdminActor,
      });
    }

    if (entry.documentChanged) {
      events.push({
        title: "Exception Document Updated",
        date: editDate,
        icon: "/assets/images/document-2 1.svg",
        tone: "updated",
        actor: globalAdminActor,
        note: entry.documentFileName || undefined,
      });
    }

    if (entry.renewalDateChanged) {
      // Close out the period this renewal replaces: announce what its deadline
      // was, and if that deadline had already passed by the time of this edit,
      // show it lapsing before the renewal - the same "Valid Till then Expired"
      // pairing used for the current/latest period.
      if (entry.previousRenewalDate) {
        const prevDate = new Date(entry.previousRenewalDate);
        events.push({
          title: `Valid Till ${this.datePipe.transform(prevDate, "dd MMMM, yyyy")}`,
          date: prevDate,
          icon: "/assets/images/valid_till.svg",
          tone: "valid",
          note: "Request Renewal Before Expiry",
        });

        if (prevDate.getTime() < editDate.getTime()) {
          events.push({
            title: "Exception Expired",
            date: this.addDays(prevDate, 1),
            icon: "/assets/images/exception-expired.svg",
            tone: "expired",
          });
        }
      }

      events.push({
        title: "Exception Renewed",
        date: editDate,
        icon: "/assets/images/exception-renewed.svg",
        tone: "renewed",
        actor: globalAdminActor,
      });
    }
  }

  /** Current/latest period only - always checked against today's date. Historical,
   *  already-superseded periods are handled inside appendEditTimelineEvents instead. */
  private pushValidTillOrExpiredEvent(
    events: ExceptionTimelineEvent[],
    renewalDate: Date | null
  ): void {
    if (!renewalDate) {
      return;
    }

    events.push({
      title: `Valid Till ${this.datePipe.transform(renewalDate, "dd MMMM, yyyy")}`,
      date: renewalDate,
      icon: "/assets/images/valid_till.svg",
      tone: "valid",
      note: "Request Renewal Before Expiry",
    });

    // No actor - expiry isn't an action anyone takes, it just happens over time.
    if (this.hasRenewalDatePassed(renewalDate)) {
      events.push({
        title: "Exception Expired",
        date: this.addDays(renewalDate, 1),
        icon: "/assets/images/exception-expired.svg",
        tone: "expired",
      });
    }
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  getRequestTimelineActor(): string {
    const countryName = this.addendum?.country?.[0]?.name;
    if (countryName) {
      return `By ${countryName} Market Admin`;
    }
    return "By Market Admin";
  }

  viewCompleteStandard(): void {
    if (!this.addendum?.standardId) {
      return;
    }

    if (
      this.addendum.standard?.standardTypeId ===
      this.standardTypeEnum.GlobalEquipmentStandard
    ) {
      this.router.navigate([
        "/view-equipments-standard-detail",
        this.addendum.standardId,
      ]);
      return;
    }

    this.router.navigate(["/view-standard-detail", this.addendum.standardId]);
  }

  private getApprovalDatesDescending(): Date[] {
    if (!this.addendum?.addendumApproval?.length) {
      return [];
    }

    return this.addendum.addendumApproval
      .map((approval) =>
        approval?.approvedDate ? new Date(approval.approvedDate) : null
      )
      .filter((date): date is Date => !!date && !isNaN(date.getTime()))
      .sort((a, b) => b.getTime() - a.getTime());
  }

  private isSameDay(first: Date | null, second: Date | null): boolean {
    if (!first || !second) {
      return false;
    }

    return (
      first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate()
    );
  }

  downloadExceptionDocument(): void {
    const document = this.getDisplayDocument();
    if (!document) {
      return;
    }
    this.onDownloadAddendumDocument(document.id, document.fileName);
  }

  shareException(): void {
    const url = window.location.href;
    const onCopied = () => {
      const modalRef = this.ngbModal.open(SuccessDialogComponent);
      modalRef.componentInstance.title = "Link Copied";
      modalRef.componentInstance.message =
        "The exception page link has been copied to your clipboard.";
      modalRef.componentInstance.showViewButton = false;
      modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
        modalRef.close();
      });
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(onCopied).catch(() => {
        this.copyShareLinkFallback(url, onCopied);
      });
      return;
    }

    this.copyShareLinkFallback(url, onCopied);
  }

  private copyShareLinkFallback(url: string, onCopied: () => void): void {
    const textarea = document.createElement("textarea");
    textarea.value = url;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      onCopied();
    } finally {
      document.body.removeChild(textarea);
    }
  }

  onOk() {
    if (this.addendumService.isCommingFromNotification) {
      this.router.navigate(["/notification-list"]);
    } else if (
      this.addendumService.isCommingFromNrbes &&
      this.addendum.standard.standardTypeId !=
      this.standardTypeEnum.GlobalEquipmentStandard
    ) {
      this.router.navigate(["/nrbeslist"]);
    } else if (
      !this.addendumService.isCommingFromNrbes &&
      this.addendum.standard.standardTypeId !=
      this.standardTypeEnum.GlobalEquipmentStandard
    ) {
      this.router.navigate(["/addendum-list"]);
    } else if (
      !this.addendumService.isCommingFromNrbes &&
      this.addendum.standard.standardTypeId ==
      this.standardTypeEnum.GlobalEquipmentStandard
    ) {
      this.router.navigate(["/equipment-addendum-list"]);
    } else if (
      this.addendumService.isCommingFromNrbes &&
      this.addendum.standard.standardTypeId ==
      this.standardTypeEnum.GlobalEquipmentStandard
    ) {
      this.router.navigate(["/view-all-equipments"]);
    }
  }
}
